import React, { useState, useEffect } from 'react';
import Modal from 'jd-library/Modal';
import styles from './confirm-delete.scss';
import Button from '../../common/Button/Button';
import withPortal from 'jd-library/withPortal';
import toastMessageActions from "jd-library/toastMessageActions";
import { useDispatch, connect } from 'react-redux';
import { updateMultiBrandProd, updateBrand } from "../../actions/products";

const ConfirmModal = props => {
    const [prodName, setProdName] = useState(props.productData.productName)
    const { btnText='', isDeactivate = false , onDelete, extraData={}, productsLength} = props || {};
    const { token='', variantIds=[], activate=0 } = extraData;
	const dispatch = useDispatch();
    useEffect(() => {
        if(prodName && prodName.length > 100){
            let truncatedName = props.productData.productName.substr(0, 100) + '...';
            setProdName(truncatedName);
        }
    }, []);
    let headerText = `Deactivate Product`;
    if(!isDeactivate) {
        headerText = `Activate Product`;
    }
    if(props.isMultiSelect && props.productsLength > 1) {
        headerText += 's';
    }
    const onBtnClick = (options = {}) => {
        props.updateMultiBrandProd({
            token,
            variantIds,
            activate: activate ? 1 : 0,
            cb: (data) => {
                if(data) {
                    props.updateBrand({
                        action: !isDeactivate ? "activate" : "deactivate"
                    });
                    const msg = `${productsLength > 1 ? productsLength + ' ' : ''}Product${productsLength > 1 ? 's' : ''} ${activate ? 'Activated' : 'Deactivated'} Successfully`;
                    dispatch(toastMessageActions.showMessage({
						message: msg,
						showReduxToast: true,
                        type: 'info',
						animationTime :5000
					}));
                    window.history.back();
                }
            }
        });
    };
    return (
        <div className={styles['add-edit-block-modal']}>
            <Modal
                settings={{
                    modalId: 'confirm-delete-modal',
                    variant: 'action'
                }}
                onHidden={() => props.onModalClose()}
            >
                <Modal.CloseIcon />
                <Modal.Header>
                    <span className={styles['title']}>{headerText}</span>
                </Modal.Header>
                <Modal.Body className={styles['modal-body']}>
                    <div className={styles['subtitle']}>
                    Are you sure you want to {isDeactivate ? 'deactivate' : 'activate'} {props.isMultiSelect && props.productsLength > 1 ? props.productsLength + ' products' : (<span className={styles['bold-text']}>{prodName}</span>)}?
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles['button-wrapper']}>
                        <Button size='lg' clickHandler={onBtnClick} className={`${isDeactivate ? styles['delete-btn'] : styles[`confirm-btn`]}`}>
                            {headerText}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        brandSelDesel: state.products.brandSelDesel,
    };
};


export default withPortal(connect(mapStateToProps, {
    updateMultiBrandProd,
    updateBrand
})(ConfirmModal) , null, 'confirm-delete-modal');

